import { FormOptionsTypes } from '@cox/core-ui8/dist/Form'
import FormCheckbox from '@cox/core-ui8/dist/FormCheckbox'
import FormDropdown from '@cox/core-ui8/dist/FormDropdown'
import FormInput, { FormInputTypes } from '@cox/core-ui8/dist/FormInput'
import FormRadioButton from '@cox/core-ui8/dist/FormRadioButton'
import Modal from '@cox/core-ui8/dist/Modal'

import { ChannelSearchModalProps } from './types'
import './ChannelSearchModal.scss'
import { CHECKMARK_WHITE } from '../../../assets/images'
import { getCheckboxOptions, getOptions } from '../../../utils/channel-lineup-util'

const ChannelSearchModal = (props: ChannelSearchModalProps) => {
  const {
    showModal,
    setShowModal,
    // Modal Header
    searchModalId = '',
    searchModalTitle = '',
    // Modal Body
    // ****** Modal Body - Search Section
    searchInputTitle = '',
    searchPlaceholder = '',
    // ****** Modal Body - Filters Section
    tvPackagesRadioButtonTitle = '',
    optionalFiltersTitle = '',
    optionalFiltersOptions = '',
    tvPacksDropdownTitle = '',
    genresDropdownTitle = '',
    lineupData = {},
    // Modal Footer
    searchModalPrimaryBtnText = '',
    searchModalSecondaryBtnText = '',
    // States
    genre,
    setGenre,
    tvPack,
    setTvPack,
    tvPackage,
    setTvPackage,
    channel,
    setChannel,
    optionalFilters,
    setOptionalFilters,
    updateLineupParams
  } = props

  const jsonOptionalFiltersOptions = optionalFiltersOptions && JSON.parse(optionalFiltersOptions)

  const { refineBody = [], searchGenre, searchTVPaks } = lineupData

  const handleSelection = (setFilterType: any, e: any) => {
    setFilterType(e.value)
  }

  const handleRadioSelection = (e: any) => {
    setTvPackage(e.value)
  }

  const handleCheckboxChange = (e: any[]) => {
    const optionalFiltersArray = e
    const selectedOptionalFilters = []
    const selectedOptionalFiltersTxt = []

    for (let i = 0; i < optionalFiltersArray.length; i++) {
      if (optionalFiltersArray[i].selected == true) {
        selectedOptionalFilters.push(optionalFiltersArray[i].param)
        selectedOptionalFiltersTxt.push(optionalFiltersArray[i].text)
      }
    }

    setOptionalFilters(selectedOptionalFilters)
  }

  const modalBody = () => {
    return (
      <div className='channel-search-modal-body'>
        <div className='search-section'>
          <FormInput
            id={'search-input'}
            title={searchInputTitle}
            name='channels'
            type={FormInputTypes.TEXT}
            placeholder={searchPlaceholder}
            value={channel}
            onChange={(e) => setChannel(e.target.value)}
          />
        </div>
        <div className='filters-section'>
          {refineBody?.length > 0 && (
            <FormRadioButton
              id={'tv-packages-radio-button'}
              title={tvPackagesRadioButtonTitle}
              name='tvPackage'
              type={FormOptionsTypes.radio}
              items={getOptions(tvPackage, refineBody)}
              onChange={(e) => handleRadioSelection(e)}
            />
          )}
          {jsonOptionalFiltersOptions?.length > 0 && (
            <FormCheckbox
              id={'optional-filters-checkboxes'}
              title={optionalFiltersTitle}
              name='optionalFilters'
              type={FormOptionsTypes.checkbox}
              items={getCheckboxOptions(optionalFilters, jsonOptionalFiltersOptions)}
              checkboxCheckMark={CHECKMARK_WHITE}
              onChange={(e) => handleCheckboxChange(e)}
            />
          )}
          {searchTVPaks?.length > 0 && (
            <FormDropdown
              id={'tv-packs-dropdown'}
              title={tvPacksDropdownTitle}
              name='tvPacks'
              type={FormOptionsTypes.dropdown}
              searchEnabled={false}
              items={getOptions(tvPack, searchTVPaks)}
              onChange={(e) => handleSelection(setTvPack, e)}
            />
          )}
          {searchGenre?.length > 0 && (
            <FormDropdown
              id={'genres-dropdown'}
              title={genresDropdownTitle}
              name='genres'
              type={FormOptionsTypes.dropdown}
              searchEnabled={false}
              items={getOptions(genre, searchGenre)}
              onChange={(e) => handleSelection(setGenre, e)}
            />
          )}
        </div>
      </div>
    )
  }

  const createSearchParamsQueryString = (searchParams: { [key: string]: string | number }[]) => {
    let searchParamsQueryString = ''
    for (let i = 0; i < searchParams.length; i++) {
      const searchParamObject = searchParams[i]
      const searchParam = Object.entries(searchParamObject).map(([key, value]) => `${key}=${value}`)
      searchParamsQueryString = searchParamsQueryString + (searchParamsQueryString == '' ? '' : '&') + searchParam
    }
    return searchParamsQueryString
  }

  const handlePrimaryBtnClick = () => {
    const searchParams: any = [{ 'filter-search-select-paks': tvPack }, { 'filter-search-select-genre': genre }]
    if (channel !== '') {
      searchParams.push({ 'filter-search-term': encodeURIComponent(channel) })
    }
    for (let i = 0; i < optionalFilters.length; i++) {
      searchParams.push({ 'filter-search-options': optionalFilters[i] })
    }
    if (tvPackage !== '') {
      searchParams.push({ 'tv-package': tvPackage })
    }
    const queryString = createSearchParamsQueryString(searchParams)
    updateLineupParams('filter', '', queryString)
    handleCloseModal()
  }

  const handleCloseModal = () => {
    setShowModal(false)
  }

  return (
    <Modal
      modalId={searchModalId}
      show={showModal}
      title={searchModalTitle}
      showFooter={true}
      primaryBtnText={searchModalPrimaryBtnText}
      primaryBtnClick={handlePrimaryBtnClick}
      secondaryBtnText={searchModalSecondaryBtnText}
      secondaryBtnisCloseBtn={true}
      children={modalBody()}
      customClassName='channel-search-modal'
      handleClose={handleCloseModal}
    />
  )
}

export default ChannelSearchModal
